import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "ckeditor5-custom-build-modern/build/ckeditor.js";
import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { Input } from "antd";
import { QuestionImageUpload } from "Components/CommonComponents/QuestionImageUpload";
const { TextArea } = Input;
const format = (node, level) => {
  var indentBefore = new Array(level++ + 1).join(""),
    indentAfter = new Array(level - 1).join(""),
    textNode;
  for (var i = 0; i < node.children.length; i++) {
    textNode = document.createTextNode(indentBefore);
    node.insertBefore(textNode, node.children[i]);
    format(node.children[i], level);
    if (node.lastElementChild == node.children[i]) {
      textNode = document.createTextNode("\n" + indentAfter);
      node.appendChild(textNode);
    }
  }
  return node;
};

const process = (str) => {
  var div = document.createElement("div");
  if (typeof str === "object" && str !== null) {
    div.innerHTML = str;
  } else {
    div.innerHTML = str.trim();
  }
  return format(div, 0).innerHTML;
};

const RichQuestionComponent = (props) => {
  const { onChange, id = "1" } = props || {};
  const [isEditing, setisEditing] = useState(false);
  const [lastAssetImport, setlastAssetImport] = useState(Date.now());
  const [controlledValue, setcontrolledValue] = useState(
    props.defaultValue ? process(props.defaultValue) : null
  );
  const lastEmittedValue = useRef(props.defaultValue || "");
  const findAsset = (data) => {
    let wrapper = document.createElement("div");
    wrapper.innerHTML = data || "";
  };
  useEffect(() => {
    if (props.defaultValue !== null && props.defaultValue !== undefined) {
      if (props.defaultValue !== lastEmittedValue.current) {
        setcontrolledValue(process(props.defaultValue));
      }
    }
  }, [props.defaultValue]);
  return (
    <div
      className="rich-question"
      style={{ whiteSpace: "normal", maxWidth: "100%", width: "100%" }}
      id={props.id ? props.id : "rq"}
    >
      <div
        className="px-2 "
        id="myHeader"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "end",
          alignItems: "center",
          background: "#fafafa",
          padding: "5px 0px 9px 0px",
          borderTop: "1px solid #c4c4c4",
          borderLeft: "1px solid #c4c4c4",
          borderRight: "1px solid #c4c4c4",
          borderRadius: "8px 8px 0px 0px",
          color: "#606060",
        }}
      >
        <div className="d-flex flex-row justify-content-start align-items-center">
          {isEditing ? (
            <label
              className="mb-0"
              style={{
                fontSize: "10px",
                paddingTop: "5px",
                cursor: "pointer",
                display: "block",
              }}
              onClick={() => {
                setisEditing(false);
                window["controlQ"] = props.controlName;
              }}
            >
              Editor
            </label>
          ) : (
            <label
              className="mb-0 ml-2"
              style={{
                fontSize: "10px",
                float: "right",
                paddingTop: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                setisEditing(true);
                window["controlQ"] = props.controlName;
              }}
            >
              View Source
            </label>
          )}
        </div>
      </div>
      {isEditing ? (
        <div key={isEditing + "Custom"} style={{ width: "100%" }}>
          <TextArea
            style={{
              width: "100%",
              minHeight: "100px",
              borderRadius: "0px 0px 8px 8px",
            }}
            defaultValue={controlledValue || ""}
            onChange={(data) => {
              let text = data["target"]["value"];
              console.log(text, "textvbalue");
              lastEmittedValue.current = text;
              setcontrolledValue(process(text));
              // onChange(text);
              if (Date.now() - lastAssetImport > 500) {
                findAsset(text, onChange, props.triggerFunction);
                setlastAssetImport(Date.now());
              }
              // editor.setData(text || '')
              if (props.triggerFunction) {
                props.triggerFunction(text);
              }
            }}
          ></TextArea>
        </div>
      ) : (
        <div>
          <CKEditor
            className={"edit-ckEditor-css"}
            style={{ borderRadius: "0px 0px 8px 8px" }}
            config={{
              mathJax: {
                // MathJax configuration
                loader:
                  "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml.js", // Or your MathJax CDN
                configuration: {
                  tex: {
                    inlineMath: [
                      ["$", "$"],
                      ["\\(", "\\)"],
                    ], // Inline math delimiters
                    displayMath: [
                      ["$$", "$$"],
                      ["\\[", "\\]"],
                    ], // Display math delimiters
                  },
                  svg: {
                    fontCache: "global",
                  },
                },
              },
              image: {
                styles: {
                  options: [
                    "inline",
                    "block",
                    "side",
                    "alignLeft",
                    "alignCenter",
                    "alignRight",
                  ],
                },
                resizeOptions: [
                  {
                    name: "imageResize:original",
                    label: "Original",
                    value: null,
                  },
                  {
                    name: "imageResize:25",
                    label: "25%",
                    value: "25",
                  },
                  {
                    name: "imageResize:50",
                    label: "50%",
                    value: "50",
                  },
                  {
                    name: "imageResize:75",
                    label: "75%",
                    value: "75",
                  },
                ],
                toolbar: [
                  "imageStyle:inline",
                  "imageStyle:block",
                  "imageStyle:side",
                  "|",
                  "imageStyle:alignLeft",
                  "imageStyle:alignCenter",
                  "imageStyle:alignRight",
                  "|",
                  "imageResize",
                  "|",
                  "imageTextAlternative",
                ],
              },
              table: {
                contentToolbar: [
                  "tableColumn",
                  "tableRow",
                  "mergeTableCells",
                  "tableCellProperties",
                  "tableProperties",
                ],
              },
              toolbar: {
                items: [
                  "bold",
                  "italic",
                  "underline",
                  "bulletedList",
                  "numberedList",
                  "|",
                  "indent",
                  "outdent",
                  "alignment",
                  "|",
                  "imageUpload",
                  "imageInline",
                  "imageInsert",
                  "insertTable",
                  "MathType",
                  "ChemType",
                  "specialCharacters",
                  "subscript",
                  "superscript",
                  "|",
                  "findReplace",
                  "undo",
                  "redo",
                  "|",
                  "heading",
                  "fontColor",
                  "fontBackgroundColor",
                  "fontSize",
                  "highlight",
                  "blockQuote",
                  "link",
                  "horizontalLine",
                  "pageBreak",
                  "fontFamily",
                  "codeBlock",
                  "code",
                  "strikethrough",
                  "removeFormat",
                ],
              },
            }}
            editor={ClassicEditor}
            data={controlledValue}
            onChange={(event, editor) => {
              const data = editor.getData();
              lastEmittedValue.current = data;
              if (onChange) onChange(data);
            }}
            disableWatchdog={true}
            onReady={(editor) => {
              if (props.isViewMode) {
                editor.isReadOnly = true;
              }
              // Connect the upload adapter using code below
              editor.plugins.get("FileRepository").createUploadAdapter =
                function (loader) {
                  return new QuestionImageUpload(loader, id);
                };
            }}
          />
        </div>
      )}
    </div>
  );
};

RichQuestionComponent.propTypes = {
  id: PropTypes?.any,
  defaultValue: PropTypes.any,
  title: PropTypes.string,
  error: PropTypes.any,
  name: PropTypes.any,
  controlName: PropTypes.any,
  triggerFunction: PropTypes.func,
  onChange: PropTypes.func,
  onInit: PropTypes.func,
  onBtnClick: PropTypes.func,
  isViewMode: PropTypes.bool,
};
export default RichQuestionComponent;
